<template>
  <div class="layout">
    <Header
      :pageTitle="'资料预览'"
      @backFn="backFn"
      :showBack="true"
      :isXue="isXue"
      v-if="isApp"
    ></Header>
    <iframe :src="path + fileUrl" frameborder="0" id="pdfIframe"></iframe>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { PdfJSUrl } from '@utils/basePath'
import { getUrlParam } from '@/widget'
import {
  validateXue,
  hiddenAppNavBar,
  appPort,
  prevPageView,
  closeAppView
} from '@/widget'
import Header from '@/components/common/Header.vue'
const isXue = validateXue()
const path = ref(PdfJSUrl + '?file=')
const fileUrl = ref(getUrlParam('url'))
const isApp = appPort()
if (isApp) {
  hiddenAppNavBar()
}
const backFn = () => {
  if (isXue) {
    closeAppView()
  } else {
    prevPageView()
  }
}
onMounted(() => {
  const name = getUrlParam('name')
  document.title = name || '资料预览'
})
</script>

<style lang="scss" scoped>
iframe {
  height: calc(100vh - 88px);
  width: 100%;
}
</style>
